import type {
  FrameXinglet,
  FrameProps,
} from '@xing-com/crate-lebenslauf-xinglets';

import { Frame as FrameComponent } from './frame';

export default class Frame implements FrameXinglet {
  public getComponent(): React.ComponentType<FrameProps> {
    return (props) => <FrameComponent {...props} />;
  }
}
